import io from "socket.io-client";
import config from '../../config/endpoints.js'
import uniqid from "uniqid";
const SOCKETHUB_ENDPOINT = config.socketHub
import _ from "lodash";
export default {
    name: 'SocketProvider',
    data: () => ({
        socket: null,
        socketId: null,
        userData: null
    }),
    computed: {
        getUserData() {
            return this.$store.getters["auth/getUserData"];
        },
    //     // inCall() {
    //     //     const status = this.$store.getters["videocall/inCallStatus"];
    //     //     return ( status == CALL_STATUS.CONNECTED || status == CALL_STATUS.IN_PROGRESS );
    //     // }
    },
    watch: {
        getUserData: {
            immediate: true,
            handler (userData, oldData) {
                if (_.isEqual(userData, oldData)) return
                let isLoggedIn = this.$store.getters["auth/getLoginStatus"];
                if (isLoggedIn && userData && userData.id) {
                    this.socketInit();
                }
            }
        },
    },
    // mounted() {
    //     // bus.$on("DECLINE_CALL", this.declineCall);
    //     // bus.$on("ACCEPT_CALL", this.acceptCall);
    //     const userData = JSON.parse(localStorage.getItem('userdetails'))
    //     console.log('userData', userData)
    //     if(userData && userData.id) {
    //         this.socketInit();
    //     }
    // },
    methods: {
        socketInit() {
            const userData = JSON.parse(localStorage.getItem('userdetails'))
            // const userId = this.$store.getters["user/getUserId"];
            const userId = userData.id
            let did = uniqid();
            this.socket = io(SOCKETHUB_ENDPOINT, {
                query: `uid=${userId}&did=${did}`,
                transports: ['websocket']
            });
            if(this.socket) {
                this.socket.on("connect", this.socketConnect);
                this.socket.on("disconnect", this.socketDisconnected);
            }
        },
        socketConnect() {
            console.log('socket connected..');
            if(this.socket&&this.socket.id) {
                // this.socket.on("INCOMING_MESSAGE", this.onMessage);
                // this.socket.on("VIDEO_CALL", this.onVideocall);
                // this.socket.on("CALL_REJECTED", this.endVideocall);
                setTimeout(() => {
                    this.socket.on("ADMIN_NOTIFICATION", this.inAppNotification)
                    this.socket.on("EMP_STATUS_NOTIFICATION", this.empStatusNotification)
                    this.socket.on("INCOMING_MESSAGE", this.getCaptainChat)
                }, 5000)
            }
        },
        socketDisconnected() {
            console.log('socket disconnected..');
        },
        inAppNotification(e) {
            console.log('COMMON', e)
            // setTimeout(() => {
            //     console.log('RUPAM')
                this.$store.dispatch("common/INAPP_NOTIFICATION", e)
            // }, 5000)
        },
        empStatusNotification(e) {
            this.$store.dispatch("common/EMP_NOTIFICATION", e)
        },
        getCaptainChat(e){
            this.$store.dispatch("common/CAPTION_NOTIFICATION", e)
        }
        // onVideocall(e) {
        //     console.log('videocall event : ', e);
        //     this.$store.dispatch("videocall/INCOMING_CALL", {
        //         isRinging: true,
        //         data: e
        //     });
        // },
        // endVideocall() {
        //     this.$store.dispatch("videocall/INCOMING_CALL", { isRinging: false });
        // },
        // onMessage(payload) {
        //     console.log('onMessage event')
        //     let notificationPayload = {
        //         data: {
        //             type: "chat",
        //             id: payload.chatroom_id,
        //             utid: payload.utid || "",
        //             status: payload.status || "",
        //             ...payload,
        //         },
        //         notification: {
        //             title: "You have a new message",
        //             body: i18n.t("fromapointid") + "" + `${payload.chatroom_id}`,
        //         },
        //     };
        //     this.$store.dispatch(
        //         "common/SET_NOTIFICATION_PAYLOAD",
        //         notificationPayload
        //     );
        //     let activeChatroom;
        //     if (this.inCall) {
        //         let callPayload = this.$store.getters["videocall/getIncomingCallPayload"];
        //         activeChatroom = callPayload.roomName;
        //     } else {
        //         activeChatroom = this.$store.getters["appointment/getActiveChatroom"];
        //     }
        //     // check if user in call and same chatroom
        //     const callStatus = this.$store.getters["videocall/callStatus"];
        //     // TODO: need to handle notificatoin from different chatroom / appointment.
        //     if (
        //         callStatus == CALL_STATUS.CONNECTED &&
        //         activeChatroom == payload.chatroom_id
        //     ) {
        //         this.$store.dispatch("socket/SET_NEW_MSG_FLAG", true);
        //         bus.$emit("CHAT_NOTIFICATION");
        //     } else if (activeChatroom && activeChatroom == payload.chatroom_id) {
        //         // check if user in same chat room
        //         bus.$emit("CHAT_NOTIFICATION");
        //     } else {
        //         this.$store.dispatch("common/SHOW_NOTIFICATION", true);
        //     }
        //     // hide notification alert after 5 seconds
        //     setTimeout(() => {
        //         this.$store.dispatch("common/SHOW_NOTIFICATION", false);
        //     }, 5000);
        // },
        // async acceptCall() {
        //     let token = await this.$store.getters["user/getToken"];
        //     let incomingPayload = await this.$store.getters[
        //         "videocall/getIncomingCallPayload"
        //     ];
        //     console.log(
        //         incomingPayload,
        //         "incomingPayloadincomingPayloadincomingPayload"
        //     );
        //     this.$store.dispatch("videocall/INCOMING_CALL", {
        //         isRinging: false,
        //         data: incomingPayload,
        //     });
        //     this.socket.emit(
        //         "ACCEPT_CALL",
        //         JSON.stringify({
        //         did: "chrome-unique",
        //         headerToken: token,
        //         dsid: incomingPayload.sid,
        //         roomName: incomingPayload.roomName,
        //         })
        //     );
        //     this.$store.dispatch(
        //         "videocall/UPDATE_CALL_STATUS",
        //         CALL_STATUS.CONNECTED
        //     );
        // },
        // async declineCall(val) {
        //     let token = await this.$store.getters["user/getToken"];
        //     let durationCall = await this.$store.getters["socket/getDuration"];
        //     let incomingPayload = await this.$store.getters[
        //         "videocall/getIncomingCallPayload"
        //     ];
        //     if(val){
        //         if (durationCall != undefined) {
        //             this.socket.emit(
        //             "REJECT_CALL",
        //             JSON.stringify({
        //                 did: "chrome-unique",
        //                 headerToken: token,
        //                 dsid: incomingPayload.sid,
        //                 roomName: incomingPayload.roomName,
        //                 duration: "00 : " + durationCall,
        //             })
        //             );
        //         } else {
        //             this.socket.emit(
        //             "REJECT_CALL",
        //             JSON.stringify({
        //                 did: "chrome-unique",
        //                 headerToken: token,
        //                 dsid: incomingPayload.sid,
        //                 roomName: incomingPayload.roomName,
        //             })
        //             );
        //         }
        //     }
        //     this.$store.dispatch("videocall/INCOMING_CALL", { isRinging: false });
        //     this.$store.dispatch("socket/SET_DURATION", undefined);
        //     this.$store.dispatch('videocall/UPDATE_CALL_STATUS', CALL_STATUS.DISCONNECTED);
        // },

    },
    render() {
        // return this.$scopedSlots.default({
        //     socket: this.socket,
        // });
        if (this.$scopedSlots.default !== undefined) {
            return this.$scopedSlots.default({
                socket: this.socket,
            });
        } 
        // else {
        //     return this.$slots.default({
        //         socket: this.socket,
        //     });
        // } 
    }
}



// WEBPACK FOOTER //
// ./src/api/SocketProvider.js